/**
 * Packery-style masonry for Banner section.
 * Mirrors BEON isotopet4s layoutMode:"packery" so later banners
 * nest up into gaps left by shorter items above them.
 */
(function () {
  var MQ_MOBILE = '(max-width: 767px)';
  // Subpixel / rounding slack so 3×33.33% columns still fit on one row.
  var FIT_EPS = 2;

  function parseGap(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function overlaps(a, b, gapX, gapY) {
    return !(
      a.x + a.w + gapX <= b.x + FIT_EPS ||
      b.x + b.w + gapX <= a.x + FIT_EPS ||
      a.y + a.h + gapY <= b.y + FIT_EPS ||
      b.y + b.h + gapY <= a.y + FIT_EPS
    );
  }

  function fits(rect, placed, gapX, gapY, containerW) {
    if (rect.x < -FIT_EPS || rect.y < -FIT_EPS) return false;
    if (rect.x + rect.w > containerW + FIT_EPS) return false;
    for (var i = 0; i < placed.length; i++) {
      if (overlaps(rect, placed[i], gapX, gapY)) return false;
    }
    return true;
  }

  function candidateYs(placed, gapY) {
    var ys = [0];
    for (var i = 0; i < placed.length; i++) {
      ys.push(placed[i].y + placed[i].h + gapY);
    }
    ys.sort(function (a, b) {
      return a - b;
    });
    var unique = [];
    for (var j = 0; j < ys.length; j++) {
      if (j === 0 || ys[j] !== ys[j - 1]) unique.push(ys[j]);
    }
    return unique;
  }

  function candidateXs(placed, gapX, itemW, containerW) {
    var xs = [0];
    for (var i = 0; i < placed.length; i++) {
      xs.push(placed[i].x);
      xs.push(placed[i].x + placed[i].w + gapX);
    }
    xs.sort(function (a, b) {
      return a - b;
    });
    var unique = [];
    for (var j = 0; j < xs.length; j++) {
      var x = xs[j];
      if (x < -FIT_EPS || x + itemW > containerW + FIT_EPS) continue;
      if (unique.length === 0 || Math.abs(x - unique[unique.length - 1]) > 0.5) {
        unique.push(x);
      }
    }
    return unique;
  }

  function resetItem(item) {
    item.style.position = '';
    item.style.left = '';
    item.style.top = '';
    item.style.width = '';
    item.style.margin = '';
  }

  function measureWidth(item) {
    // Floor to avoid cumulative browser rounding pushing N equal columns
    // just over the container (which drops the last item to the next row).
    var rect = item.getBoundingClientRect();
    return Math.max(0, Math.floor(rect.width));
  }

  function layoutGrid(grid) {
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.children);
    if (!items.length) return;

    if (window.matchMedia(MQ_MOBILE).matches) {
      grid.style.height = '';
      grid.classList.remove('kl-banner__grid--packed');
      items.forEach(resetItem);
      return;
    }

    var styles = window.getComputedStyle(grid);
    var gapX = parseGap(styles.columnGap || styles.gap);
    var gapY = parseGap(styles.rowGap || styles.gap);
    var containerW = grid.clientWidth;

    // Measure natural widths while in flow, then pack absolutely.
    grid.classList.remove('kl-banner__grid--packed');
    grid.style.height = '';
    items.forEach(resetItem);

    var measures = items.map(function (item) {
      return {
        el: item,
        w: measureWidth(item),
        h: item.offsetHeight
      };
    });

    grid.classList.add('kl-banner__grid--packed');

    var placed = [];
    var maxBottom = 0;

    measures.forEach(function (m) {
      var best = null;
      var itemW = Math.min(m.w, containerW);
      var ys = candidateYs(placed, gapY);
      var xs = candidateXs(placed, gapX, itemW, containerW);

      for (var yi = 0; yi < ys.length; yi++) {
        for (var xi = 0; xi < xs.length; xi++) {
          var x = xs[xi];
          // Shrink slightly into remaining row space when subpixels would wrap.
          var avail = containerW - x;
          var w = itemW > avail && itemW <= avail + FIT_EPS ? avail : itemW;
          if (w <= 0) continue;
          var rect = { x: x, y: ys[yi], w: w, h: m.h };
          if (!fits(rect, placed, gapX, gapY, containerW)) continue;
          if (
            !best ||
            rect.y < best.y ||
            (rect.y === best.y && rect.x < best.x)
          ) {
            best = rect;
          }
        }
        // First row of Y that found a fit is enough (top-most).
        if (best && best.y === ys[yi]) break;
      }

      if (!best) {
        best = {
          x: 0,
          y: maxBottom + (placed.length ? gapY : 0),
          w: itemW,
          h: m.h
        };
      }

      m.el.style.position = 'absolute';
      m.el.style.left = best.x + 'px';
      m.el.style.top = best.y + 'px';
      m.el.style.width = best.w + 'px';
      m.el.style.margin = '0';

      placed.push(best);
      maxBottom = Math.max(maxBottom, best.y + best.h);
    });

    grid.style.height = maxBottom + 'px';
  }

  function layoutAll(root) {
    var scope = root || document;
    var grids = scope.querySelectorAll
      ? scope.querySelectorAll('.kl-banner__grid')
      : [];
    Array.prototype.forEach.call(grids, layoutGrid);
  }

  function init() {
    layoutAll();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        layoutAll();
      }, 100);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        layoutAll();
      });
    }

    // Images can change item height after load.
    document.querySelectorAll('.kl-banner__img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        layoutAll();
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      layoutAll(event.target);
    });
    document.addEventListener('shopify:section:reorder', function () {
      layoutAll();
    });
    document.addEventListener('shopify:block:select', function (event) {
      layoutAll(event.target && event.target.closest ? event.target.closest('.kl-banner') : null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
